import { Dispatch, Action } from 'redux'
import { UploadedFileCardMapDispatchReturnType } from './types/UploadedFileCardMapDispatchReturnType'

export const UploadedFileCardMapDispatch = (
  _dispatch: Dispatch<Action>
): UploadedFileCardMapDispatchReturnType => {
  return {}
}
